// ==================================================================================== ACCORDION REUSABLE FUNCTION
function createAccordionAnimation(
  containerSelector,
  groupSelector,
  menuSelector,
  contentSelector,
  openIconSelector,
  closeIconSelector,
  imageSelector, 
  toggleFirstMenu = false
) {
  let groups = gsap.utils.toArray(groupSelector, document.querySelector(containerSelector));
  let menus = gsap.utils.toArray(menuSelector, document.querySelector(containerSelector));
  let images = gsap.utils.toArray(imageSelector, document.querySelector(containerSelector));
  let menuToggles = groups.map(createAnimation);
  menus.forEach((menu) => {
    menu.addEventListener("click", () => toggleMenu(menu));
  });
  function toggleMenu(clickedMenu) {
    menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
  }
  function updateActiveElements(activeIndex) {
    images.forEach((img, index) => {
      img.classList.toggle('co-active', index === activeIndex);
    });
    groups.forEach((group, index) => {
      group.classList.toggle('co-active', index === activeIndex);
    });
  }
  function createAnimation(element, index) {
    let menu = element.querySelector(menuSelector);
    let box = element.querySelector(contentSelector);
    let minusElement = element.querySelector(openIconSelector);
    let plusElement = element.querySelector(closeIconSelector);
    gsap.set(box, { height: "auto" });
    let animation = gsap
      .timeline()
      .from(box, {
        height: 0,
        duration: 0.5,
        ease: "power3.inOut"
      })
      .from(minusElement, { duration: 0.1, autoAlpha: 0, ease: "none" }, 0)
      .to(plusElement, { duration: 0.1, autoAlpha: 0, ease: "none" }, 0)
      .reverse();
    return function (clickedMenu) {
      if (clickedMenu === menu) {
        animation.reversed(!animation.reversed());
        if (!animation.reversed()) {
          updateActiveElements(index);
        }
      } else {
        animation.reverse();
      }
    };
  }
  if (toggleFirstMenu && menus.length > 0) {
    toggleMenu(menus[0]);
  }
}
// ==================================================================================== SECTION 1
// ========================================== ACCORDION FUNCTION
createAccordionAnimation(
  ".co-careers-section-1",       
  ".co-careers-section-1-accordion-group",
  ".co-careers-section-1-accordion-menu",  
  ".co-careers-section-1-accordion-content", 
  ".co-careers-section-1-accordion-open",   
  ".co-careers-section-1-accordion-close",
  ".co-careers-section-1-images",
  true
);